export function disableReturn() {
	return (event: KeyboardEvent): void => {
		if (event.key === 'Enter') {
			event.preventDefault();
		}
	};
}
